export default __webpack_public_path__ + "static/media/arrow-left.62dff386.svg";